import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const celebContainer = styled.div`
  padding: 80px 10px 0px 10px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  padding: 10px;
`;

export const profileImageCircle = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ccc;
  ${MQ.MediaMd} {
    width: 200px;
    height: 200px;
  }
`;

export const profileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const TitleContainer = styled.div`
  color: ${colors.PrimaryWhiteColor};
  display: flex;
  justify-content: start;
  flex-direction: column;
  padding-left: 36px;
`;

export const commonTitleStyles = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(14, 14)};
  ${MQ.MediaSm} {
    ${ZeeFontBold(18, 18)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontBold(24, 24)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(24, 24)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(36, 36)};
  }
`;

export const CelebCast = styled.div`
  gap: 8px;
  ${flex()};
  color: ${colors.PrimaryWhiteColor};
`;

export const Cast = styled.li`
  &:nth-child(1) {
    list-style-type: none;
  }
  padding: 10px 10px 0px 0px;
  ${ZeeFontMedium(10, 14)};
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 14)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(20, 20)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontMedium(20, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(24, 24)};
  }
`;

export const castTypeContainer = styled.span`
  margin-left: 0px;
`;

export const Filmography = styled.div`
  cursor: pointer;
  ${ZeeFontBold(10, 18)};
  color: ${colors.PurpleLight};
  padding-top: 10px;
  ${MQ.MediaSm} {
    ${ZeeFontBold(12, 12)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontBold(14, 16)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(14, 16)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(16, 16)};
  }
`;

export const ThumbnailStyle1 = css`
  display: grid;
  gap: 2px 2px;
  grid-template-columns: auto auto;
  padding: 8px;
  ${MQ.MediaSm} {
    grid-template-columns: auto auto auto auto auto;
  }
  ${MQ.MediaMd} {
    grid-template-columns: auto auto auto auto auto;
  }
  ${MQ.MediaLg} {
    margin: 0px 160px;
  }
`;

export const ThumbnailStyle = css`
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  padding: 8px;
`;

export const CastContent = css`
  color: ${colors.PrimaryWhiteColor};
  margin: 0px 15px;
  text-transform: capitalize;
  ${ZeeFontMedium(18, 24)};
  ${MQ.MediaSm} {
    ${ZeeFontMedium(20, 28)};
  }
  ${MQ.MediaMd} {
    ${ZeeFontMedium(24, 32)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontMedium(30, 40)};
    margin: 25px 175px 0px;
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(30, 40)};
  }
`;

export const LoadMore = css`
  color: ${colors.PrimaryWhiteColor};
  border: 1px solid ${colors.PrimaryWhiteColor};
  padding: 4px 16px;
  border-radius: 6px;
  text-align: center;
  ${ZeeFontMedium(12, 18)};
  ${MQ.MediaMd} {
    ${ZeeFontRegular(14, 22)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(16, 22)};
    margin: 16px 175px 0px;
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(16, 22)};
    margin: 16px 175px 0px;
  }
`;

export const CelebSEO = css`
  ${MQ.MediaLg} {
    margin: 16px 175px 0px;
  }
  ${MQ.MediaXl} {
    margin: 16px 175px 0px;
  }
`;

export const CelebsMain = styled.div`
  height: 100%;
  ${MQ.MediaLg} {
    margin: 0px 160px;
  }
  ${MQ.MediaXl} {
    margin: 0px 160px;
  }
`;

export const CelebsDetails = styled.p`
  overflow: hidden;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: ${colors.TintedGrey50};
  margin: 18px 18px 0px 18px;
  ${MQ.MediaSm} {
    -webkit-line-clamp: 2;
  }
`;

export const Details = styled.span`
  color: ${colors.Lavender};
  margin: 0px 18px;
  cursor: pointer;
`;

export const titleDescription = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(16, 20)}
  margin: 20px 16px 0 16px;
  ${MQ.MediaSm} {
    ${ZeeFontBold(16, 22)};
  }
  ${MQ.MediaLg} {
    ${ZeeFontBold(24, 36)};
  }
`;

export const seoDescriptionTop = css`
  margin: 20px 16px 0 16px;
`;
